
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#9D9D9D","stroke-width":"1.5"}},[_c('circle',{attrs:{"cx":"6.5","cy":"6.5","r":"5.75"}}),_c('path',{attrs:{"d":"M11 11l4 4","stroke-linecap":"round"}})])])
          )
        }
      }
    